import { sum } from "lodash";
import { isRealNumber } from "features/Sheets/ManageSheet";
import { calculateTotalCosts } from "./CalculateTotalCosts";

export const calculateTotalInvestment = (capitalFundingSection) => {
  const { settlements, ipSettlements, adminSettlements } =
    capitalFundingSection;

  return capitalFundingSection
    ? calculateTotalCosts(capitalFundingSection) +
        sum(
          [
            ...(settlements ?? []),
            ...(ipSettlements ?? []),
            ...(adminSettlements ?? []),
          ].map((s) => {
            const value = parseFloat(s.value?.value);
            if (!isRealNumber(value)) return 0;
            return value;
          }),
        )
    : 0;
};
